<template>
	<div>
		<Clist :ShowFilas="false" :pShowBtnAdd="false" :EmitSeccion="EmitSeccion" :regresar="false" @FiltrarC="Lista" :Filtro="Filtro" :Nombre="NameList" :isModal="EsModal" :Total="TotalPagina" :pConfigLoad="ConfigLoad">
			<template slot="Filtros">
				<div class="form-group mr-2">
					<label for="">Tipo de Servicio</label>
					<select @change="Lista();GetTipoSer();" class="ml-2 form-control" v-model="Filtro.IdConfigS">
						<option value="">Todos</option>
						<option value="1">Mantenimiento</option>
						<option value="2">Servicio</option>
						<option value="3">Proyecto</option>
					</select>
				</div>
				<div class="form-group mr-2">
					<label for="">SubTipo de Servicio</label>
					<select @change="Lista" name="" id="" class="ml-2 form-control" v-model="Filtro.IdTipoSer">
						<option value="">- SubTipo de Servicio -</option>
						<option :value="item.IdTipoSer" v-for="(item,index) in ListaTipoSer" :key="index">{{item.Concepto}}</option>
					</select>
				</div>
			</template>
			<template slot="header">
				<tr>
					<th>Número de Contrato</th>
					<th>Cliente</th>
					<th>Propiedad</th>
					<th>Tipo</th>
					<th>SubTipo</th>
					<th>Spend Plan</th>
					<th>Venta</th>
					<th>Valor Venta</th>
					<th>Acciones</th>
				</tr>
			</template>
			<template slot="body">
				<tr v-for="(item,key,index) in Ventas" :key="index">
					<td v-b-tooltip.hover.top :title="item.NumeroC">{{$limitCharacters(item.NumeroC,17)}}</td>
					<td>{{$limitCharacters(item.Cliente,20)}}</td>
                	<td v-b-tooltip.hover.top :title="item.Propiedad">{{$limitCharacters(item.Propiedad,20)}}</td>
					<td>{{GetTipoServicio(item.IdConfigS)}}</td>
                	<td>{{item.TipoServicio}}</td>
					<td><i class="fa fa-calendar"></i> {{item.FechaSpendPlan==null ? 'S/F' : $getCleanDate(item.FechaSpendPlan,false)}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaVenta,false)}}</td>
					<td>$ {{Number( item.ValorVenta).toLocaleString("es-MX")}}</td>
					<td>
						<button v-if="item.FechaInicio!=null && item.FechaSpendPlan!=null"  @click="IrASpendPlan(item,'ver')" v-b-tooltip.hover.top title="Ver Spend Plan" type="button" class="btn-icon mr-2"><i class="fa fa-eye"></i></button>
						<button v-if="item.FechaInicio!=null && item.FechaSpendPlan==null && item.SpendPlan=='2'" @click="IrASpendPlan(item,'crear')" v-b-tooltip.hover.top title="Crear Spend Plan" type="button" class="btn-icon mr-2"><i class="fa fa-plus-circle"></i></button>
						<button v-if="Perfil=='Admin' && item.FechaInicio!=null && (item.FechaSpendPlan!=null || item.SpendPlan=='1')" @click="IrASpendPlan(item,'editar')" v-b-tooltip.hover.top title="Editar Spend Plan" type="button" class="btn-icon mr-2"><i class="fa fa-pencil"></i></button>
						<button v-if="item.FechaInicio==null" type="button" v-b-tooltip.hover.top title="Complementar Información en Cierre de Venta" class="btn-icon-02"><i class="fa fa-exclamation"></i></button>
					</td>
				</tr>
			</template>
		</Clist>
	</div>
</template>

<script>
import Clist from "@/components/Clist.vue";
import Cbtnaccion from "@/components/Cbtnaccion.vue";
import CSinRegistros from "@/components/CSinRegistros.vue";
import Cbtnsave2 from "@/components/Cbtnsave2.vue";
export default {
	name:'ventas',
	components:{
        Clist,
        Cbtnaccion,
        CSinRegistros,
        Cbtnsave2
    },
	data() {
		return {
			EmitSeccion:'ventas',
			EsModal:false,
			NameList:"Ventas",
			FormName:'ventas',
			Pag:0,
            TotalPagina:2,
			Filtro:{
                Nombre:"",
                Placeholder:"Cliente / Propiedad / Contrato...",
                TotalItem:0,
                Pagina:1,
                Entrada:20,
				IdConfigS:'',
				IdTipoSer:'',
				Mes:'',
				OrdenContrato:'DESC',
				Anio:''
            },
			ConfigLoad:{
	    		ShowLoader:true,
	    		ClassLoad:true,
	    	},
			Ventas:[],
			ListaTipoSer:[],
			ListaAnios:[],
			Perfil:''
		}
	},
	methods: {
		async Lista(){
			this.ConfigLoad.ShowLoader=true;
			await this.$http.get('ventas/get',{
				params:{
                    Nombre:this.Filtro.Nombre,
                    Entrada:this.Filtro.Entrada,
                    pag:this.Filtro.Pagina,
					IdConfigS:this.Filtro.IdConfigS,
					IdTipoSer:this.Filtro.IdTipoSer,
					Mes:this.Filtro.Mes,
					Anio:this.Filtro.Anio,
					OrdenContrato:this.Filtro.OrdenContrato,
					// Origen:'spendplan'
                }
			}).then((res)=>{
				this.Ventas=res.data.data.ventas;
                this.Filtro.Entrada=res.data.data.pagination.PageSize;
                this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
			}).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
		},
		GetTipoServicio(Numero){
			let Cadena='';
			switch (parseInt(Numero)) {
				case 1:
					Cadena="Mantenimiento";
					break;
				case 2:
					Cadena="Servicio";
					break;
				case 3:
					Cadena="Proyecto";
					break;
			}
			return Cadena;
		},
		IrASpendPlan(Venta,Accion){
			this.$router.push({name:'spendproyectomantenimiento',params:{pVenta:Venta,pAccion:Accion}});
		},
		async GetTipoSer(){
			await this.$http.get('tiposervicio/get',{
				params:{
					RegEstatus:'A',
					IdConfigS:this.Filtro.IdConfigS,
					// IdTipoServ:this.contract.IdTipoServ,
					Entrada:''
				}
			}).then( (res) => {
				this.ListaTipoSer=res.data.data.tiposervicio;
			});
		},
	},
	created(){
        // this.bus.$off('Delete_'+this.EmitSeccion);
        this.bus.$off('List');
        this.bus.$off('Regresar');
		this.bus.$on('Regresar',()=>{
			this.$router.push({name:'submenuventas'});
		});
        // this.get_anios();

        // this.bus.$on('Delete_'+this.EmitSeccion,(Id)=>
        // {
        //     this.Eliminar(Id);
        // });

        this.bus.$on('List',()=>
        {
            this.Lista();
        });
    },
	mounted() {
		let usuario=JSON.parse(sessionStorage.getItem("user"));
		this.Perfil=usuario.Perfil;
		this.Lista();
	},
}
</script>

<style>

</style>
